const ERROR_CN = Object.freeze({
  'error.validation.required': '必填项目',
  'error.validation.email.format': '电邮格式错误',
  'error.validation.password.pattern': '密码长度至少为8个字元, 并至少包含一个数字及一个字母',
  'error.validation.confirm.password.mismatch': '两次输入密码不一致，请重新输入',
  'error.validation.no.whitespace': '字串不能存在空格',

  // Login
  'error.login.fail.title': '登入失败',
  'error.login.fail.description': '请检查帐户密码是否正确',

  // Forgot password
  'error.forgot-password.fail.title': '忘记密码发生错误',
  'error.forgot-password.fail.description': '请稍候再试过',

  // Reset forgot password
  'error.reset-forgot-password.fail.title': '重设密码发生错误',
  'error.reset-forgot-password.fail.description': '请稍候再试过',

  'error.common': '发生错误',
  'error.referral.INVALID_JWT_TOKEN': '认证码不正确, 请联络客服',
  'error.referral.TOKEN_ALREADY_USED': '认证码已被使用, 请联络客服',
});

export { ERROR_CN };
